<div class="filter-container">
  <div class="offcanvas-header">
    <h4 class="offcanvas-title">{{'filters.title' | translate}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="this.filter.setFilterVisibility(false)"></button>
  </div>

  <div class="offcanvas-body">
    @if (this.filter.filteredSightings) {
      <div class="filter-body">
        <p class="counter">
          {{'filters.showing' | translate | datainterpreter:'count':this.filter.filteredSightings.length:'total':this.filter.totalNumber}}
        </p>
        <!-- Datepicker-->
        <div class="dp-hidden position-absolute">
          <div class="input-group">
            <input
              name="datepicker"
              class="form-control hidden-datepicker"
              ngbDatepicker
              #datepicker="ngbDatepicker"
              [autoClose]="'outside'"
              (dateSelect)="uploadRange.onDateSelection($event); updateFilter()"
              [displayMonths]="2"
              [dayTemplate]="t"
              outsideDays="hidden"
              [startDate]="uploadRange.fromDate!"
              tabindex="-1"
              container="body"
              [minDate]="{year: this.filter.firstUploadYear, month: 1, day: 1}" [maxDate]="{year: thisYear, month: 12, day: 31}"
              />
            <ng-template #t let-date let-focused="focused">
              <span
                class="custom-day"
                [class.focused]="focused"
                [class.range]="uploadRange.isRange(date)"
                [class.faded]="uploadRange.isHovered(date) || uploadRange.isInside(date)"
                (mouseenter)="uploadRange.hoveredDate = date"
                (mouseleave)="uploadRange.hoveredDate = null"
                >
                {{ date.day }}
              </span>
            </ng-template>
          </div>
        </div>
        <!-- Form Inputs -->
        <form class="row date-row">
          <div class="col-6 date-holder">
            <p>{{'filters.uploaded_from' | translate}}</p>
            <div class="input-group">
              <input
                #dpFromDate
                class="form-control"
                placeholder="{{'filters.no_filter' | translate}}"
                name="dpFromDate"
                [value]="formatter.format(uploadRange.fromDate)"
                (input)="uploadRange.fromDate = uploadRange.validateInput(uploadRange.fromDate, dpFromDate.value)"
                readonly="true"
                (click)="datepicker.toggle()"
                />
              <button class="btn btn-sm btn-outline-warning" (click)="uploadRange.fromDate = null; updateFilter()" type="button"><fa-icon icon="x"></fa-icon></button>
            </div>
          </div>
          <div class="col-6 date-holder">
            <p>{{'filters.uploaded_to' | translate}}</p>
            <div class="input-group">
              <input
                #dpToDate
                class="form-control"
                placeholder="{{'filters.no_filter' | translate}}"
                name="dpToDate"
                [value]="formatter.format(uploadRange.toDate)"
                (input)="uploadRange.toDate = uploadRange.validateInput(uploadRange.toDate, dpToDate.value)"
                readonly="true"
                (click)="datepicker.toggle()"
                />
              <button class="btn btn-sm btn-outline-warning" (click)="uploadRange.toDate = null; updateFilter()" type="button"><fa-icon icon="x"></fa-icon></button>
            </div>
          </div>
        </form>
        <!-- Datepicker-->
        <div class="dp-hidden position-absolute">
          <div class="input-group">
            <input
              name="datepicker2"
              class="form-control hidden-datepicker"
              ngbDatepicker
              #datepicker2="ngbDatepicker"
              [autoClose]="'outside'"
              (dateSelect)="spottedRange.onDateSelection($event); updateFilter()"
              [displayMonths]="2"
              [dayTemplate]="t2"
              outsideDays="hidden"
              [startDate]="spottedRange.fromDate!"
              tabindex="-1"
              container="body"
              [minDate]="{year: this.filter.firstSpottedYear, month: 1, day: 1}" [maxDate]="{year: thisYear, month: 12, day: 31}"
              />
            <ng-template #t2 let-date let-focused="focused">
              <span
                class="custom-day"
                [class.focused]="focused"
                [class.range]="spottedRange.isRange(date)"
                [class.faded]="spottedRange.isHovered(date) || spottedRange.isInside(date)"
                (mouseenter)="spottedRange.hoveredDate = date"
                (mouseleave)="spottedRange.hoveredDate = null"
                >
                {{ date.day }}
              </span>
            </ng-template>
          </div>
        </div>
        <!-- Form Inputs -->
        <form class="row date-row">
          <div class="col-6 date-holder">
            <p>{{'filters.spotted_from' | translate}}</p>
            <div class="input-group">
              <input
                #dpFromDate2
                class="form-control"
                placeholder="{{'filters.no_filter' | translate}}"
                name="dpFromDate2"
                [value]="formatter.format(spottedRange.fromDate)"
                (input)="spottedRange.fromDate = spottedRange.validateInput(spottedRange.fromDate, dpFromDate.value)"
                readonly="true"
                (click)="datepicker2.toggle()"
                />
              <button class="btn btn-sm btn-outline-warning" (click)="spottedRange.fromDate = null; updateFilter()" type="button"><fa-icon icon="x"></fa-icon></button>
            </div>
          </div>
          <div class="col-6 date-holder">
            <p>{{'filters.spotted_to' | translate}}</p>
            <div class="input-group">
              <input
                #dpToDate2
                class="form-control"
                placeholder="{{'filters.no_filter' | translate}}"
                name="dpToDate2"
                [value]="formatter.format(spottedRange.toDate)"
                (input)="spottedRange.toDate = spottedRange.validateInput(spottedRange.toDate, dpToDate.value)"
                readonly="true"
                (click)="datepicker2.toggle()"
                />
              <button class="btn btn-sm btn-outline-warning" (click)="spottedRange.toDate = null; updateFilter()" type="button"><fa-icon icon="x"></fa-icon></button>
            </div>
          </div>
        </form>
        <!------------------------------------------------------------------->
        <!------------------------------------------------------------------->
        <!-------------------------------------------------------------------><!------------------------------------------------------------------->
        <div ngbAccordion>
          @for (filter of this.filters; track filter) {
            <div ngbAccordionItem>
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton class="{{filter.filter.isActive ? 'active-filter' : ''}}">
                  {{filter.lang|translate}}<span>
                  {{'filters.active' | translate | datainterpreter:'active':filter.filter.activeCount:'total':filter.filter.filters.length}}
                </span>
              </button>
            </h2>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>
                  <filter-panel [filter]="filter.filter"></filter-panel>
                </ng-template>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="filter-footer">
        <button class="btn btn-primary" (click)="clearFilters()">{{'filters.clear'|translate}}</button><br>
        <button class="mt-3 btn btn-outline-primary" (click)="report()">{{'filters.report'|translate}}</button>
      </div>
    </div>
  }
</div>




</div>